import React, { useEffect } from 'react';
import { ConfirmDeleteMessage } from '../../extras/toastMessages';
import { ACTION_EDIT, ACTION_DELETE } from '../../extras/actionTypes';
import TableList from '../../layout/TableList';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { listDependencyTypesAction, editDependencyTypesAction, deleteDependencyTypesAction } from '../../../actions/dependencyTypesActions';
import { MSG_DELETE, MSG_NOT_REVERT_OPERATION } from '../../../constants/messages';
import { Spinner } from 'react-bootstrap';
import AuthoritiesService from '../../../services/AuthoritiesService';
import { PARAMETROS_ELIMINAR, PARAMETROS_MODIFICAR } from '../../../data/objects';
//Función principal
const DependencyTypeList = props => {
    const params = {
        sort: 'descripcion:asc'
    }
    //Tomo los props
    const { handleOpen, handleClose } = props;
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const dependencyTypesLoading = useSelector( state => state.dependencyTypes.loading );
    const dependencyTypes = useSelector( state => state.dependencyTypes.dependencyTypes );
    const authorities = useSelector(state => state.auth.authorities);
    //Manejo de la edición
    const handleEdit = item => {
        //Llamo al dispatch de edición
        dispatch( editDependencyTypesAction(item, handleOpen) );
    }
    //Manjo la eliminación
    const handleDelete = item => {
        //Confirmación
        ConfirmDeleteMessage(
            MSG_DELETE,
            MSG_NOT_REVERT_OPERATION,
            () => {
                dispatch( deleteDependencyTypesAction(item) )
            }
        )
    }
    //Inicializo las cabeceras
    const headers = [
        {
            name: 'Descripción',
            width: null,
            style: null,
            field: 'descripcion'
        },
        {
            name: 'Acción',
            width: '10%',
            style: 'text-center',
            actions: [
                {
                    name: ACTION_EDIT,
                    handle: handleEdit,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_MODIFICAR)
                },
                {
                    name: ACTION_DELETE,
                    handle: handleDelete,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_ELIMINAR)
                }
            ]
        }
    ];
    //Cargo los datos
    useEffect(() => {
        dispatch( listDependencyTypesAction(params) );
    }, []);
    //Renderizo
    return (
        <div className="row">
            <div className="col-12">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                    <h6 className="m-0 font-weight-bold text-primary">Listado</h6>
                    </div>
                    <div className="card-body">
                        {
                            dependencyTypesLoading ? (
                                <Spinner animation="border" role="status">
                                    <span className="sr-only">Cargando...</span>
                                </Spinner>
                            ) : null
                        }
                        {
                            dependencyTypes ? (
                                <TableList
                                    prefix="dpt"
                                    headers={headers}
                                    items={dependencyTypes}
                                    state={{
                                        field: 'activo',
                                        disabledClass: 'table-danger',
                                        disabledValue: 0,
                                        hideActions: true
                                    }}
                                />
                            ) : null
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DependencyTypeList;